export const CheckoutStep = {
    BILLING_INFORMATION: 'billing',
    IDENTITY_VERIFICATION: 'idv',
    CONFIRM_ORDER: 'confirm_order',
    CHECKOUT_COMPLETE: 'checkout_complete',
    APPROVED: 'approved',
    CREDIT_LINE_APPROVED: 'credit_line_approved',
    DENIED: 'denied',
    MANUAL_REVIEW: 'manual_review',
};
